import {ApiSerializer} from '../../../../serializers/ApiSerializer';
import {ApplicantScreeningReport, ScreeningCultureFit} from '../../../../types/ApplicantScreeningReport';

type ApiCultureFit = {
  fitScore?: number;
  companyAverageCultureAnalysisInternalFit?: number;
  averageCompanyEmployeeFit?: number;
  averageCompanyApplicantFit?: number;
};

export const serializeApplicantScreeningReport = (data: unknown): ApplicantScreeningReport => {
  const report = ApiSerializer.toCamelCase(data) as ApplicantScreeningReport & {cultureFit?: ApiCultureFit};
  const rawCultureFit = report.cultureFit;

  const cultureFit: ScreeningCultureFit = {
    fitScore: rawCultureFit?.fitScore ?? 0,
    averageCompanyEmployeeFit:
      rawCultureFit?.averageCompanyEmployeeFit ?? rawCultureFit?.companyAverageCultureAnalysisInternalFit ?? 0,
    averageCompanyApplicantFit: rawCultureFit?.averageCompanyApplicantFit ?? 0,
  };

  return {
    ...report,
    cultureFit,
  };
};
